<template>
  <v-container class="pa-4">
    <v-row class="title-row">
      <h1 class="H2">{{ title }}</h1>
    </v-row>
    <linked-content :linkedContent="linkedContent" />
    <v-row class="description-row">
      <div class="description" v-html="description" />
    </v-row>
    <v-row v-if="imageFiles && imageFiles.length" class="image-files-row">
      <image-carousel
        :images="imageFiles"
        :imagesWidth="140"
        :imagesHeight="86"
      />
    </v-row>
    <location-component v-if="location" :location="location" />
    <dresscode v-if="dresscode" :dresscode="dresscode" />
    <related-pages v-if="relatedPages.length" :relatedPages="relatedPages" />
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import { getTextValue } from '@/lib/helpers/LocalizedText'
import marked from 'marked'


export default {
  computed: {
    ...mapState({
      page: state => state.pages.page,
    }),
    title () {
      return this.page ? getTextValue(this.page.pageSpecific.title) : ''
    },
    description () {
      const description = this.page ? getTextValue(this.page.pageSpecific.description) : ''
      return marked(description).replace(this.isLight ? /( |<([^>]+)>)/ig : '', ' ')
    },
    linkedContent () {
      const linkedContent = this.page ? this.page.linkedContent : []
      return linkedContent.length > 1 ? linkedContent.sort((linkedContentA, linkedContentB) => linkedContentA.order - linkedContentB.order) : linkedContent
    },
    relatedPages () {
      return this.page ? this.page.relatedPages : []
    },
    imageFiles () {
      return this.page ? this.page.pageSpecific.imageFiles : []
    },
    dresscode () {
      if (!this.page || !this.page.pageSpecific.dressCode || this.page.pageSpecific.dressCode.length === 0) return ''
      return this.page ? getTextValue(this.page.pageSpecific.dressCode) : null
    },
    location () {
      return this.page ? this.page.pageSpecific.location : null
    },
  },
  components: {
    LinkedContent: () => import('@/components/view-components/webapp-pages/page-objects/LinkedContent.vue'),
    LocationComponent: () => import('@/components/view-components/webapp-pages/page-objects/Location.vue'),
    Dresscode: () => import('@/components/view-components/webapp-pages/page-objects/Dresscode.vue'),
    RelatedPages: () => import('@/components/view-components/webapp-pages/page-objects/RelatedPages.vue'),
    ImageCarousel: () => import('@/components/app-components/ImageCarousel.vue'),
  },
}
</script>
<style>
.title-row {
  padding: 30px 12px 5px;
}

.image-files-row {
  padding: 30px 0px 40px 12px;
}

.description-row {
  padding: 5px 12px 20px;
}

.description > * {
  font-family: 'Mukta Mahee';
}
</style>